import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import SearchOrdersStyle from "../../../styles/searchOrdersStyle";
import names from "../../../constants/name.constant";
import Button from "@material-ui/core/Button";
import contentPaste from "../../../assets/contentPaste.svg";
import Card from "../../subComponents/cards";
import ScheduledVisitCard from "../../subComponents/scheduledVisitCard";
import CommentView from "../../commentView";
import MainPage from "../../mainPage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import videoIcon from "../../../assets/video.svg";
import phoneIcon from "../../../assets/phone.svg";

class SearchOrders extends React.Component {
  searchData = () => {
    let { SearchData, searchDataFields } = this.props;
    SearchData && SearchData(searchDataFields);
  };

  _handleRouteChange = (event, newValue, data) => {
    let { handleRouteChange } = this.props;
    handleRouteChange &&
      handleRouteChange(event, newValue === 0 ? 0 : "searchOrders", data);
  };

  getCards(pendingFilesData) {
    let cardsUI = [];
    let CardsGrid = [];
    let { searchError, classes } = this.props;
    pendingFilesData &&
      pendingFilesData !== 0 &&
      pendingFilesData.forEach((data, index) => {
        if (data.VisitType === 2) {
          cardsUI.push(
            <Grid key={index} item xl={4} lg={4} md={6} sm={6} xs={12}>
              <Card
                isSearchType={true}
                routePath="searchOrders"
                handleRouteChange={this._handleRouteChange}
                src={contentPaste}
                data={data}
              />
            </Grid>
          );
        } else if (data.VisitType === 1 || data.VisitType === 0) {
          cardsUI.push(
            <Grid key={index} item xl={4} lg={4} md={6} sm={6} xs={12}>
              <ScheduledVisitCard
                isSearchType={true}
                routePath="scheduleCards"
                handleRouteChange={this._handleRouteChange}
                src={data.VisitType === 1 ? phoneIcon : videoIcon}
                data={data}
              />
            </Grid>
          );
        }
      });
    if (searchError) {
      CardsGrid.push(
        <CommentView
          _style={{ width: 572, whiteSpace: "pre" }}
          key="commentView"
        >
          {searchError === 1 ? (
            <div>One or more of your search inputs are invalid.</div>
          ) : searchError === 2 ? (
            <div className={classes.errorWrapper}>
              <div>One or more of your search inputs are invalid.</div>
              <div>
                Please enter one or more pieces of data into the search fields
                above.
              </div>
            </div>
          ) : null}
        </CommentView>
      );
    } else {
      CardsGrid.push(
        <Grid container spacing={1}>
          {cardsUI}
        </Grid>
      );
    }
    return CardsGrid;
  }
  onTextChange = (e) => {
    let { name, value } = e.target;
    let { setSearchDataFields, searchDataFields } = this.props;
    setSearchDataFields({ ...searchDataFields, [name]: value });
  };

  onStartDateChange = (date) => {
    let { setSearchDataFields, searchDataFields } = this.props;
    setSearchDataFields({ ...searchDataFields, startDate: date });
  };

  onEndDateChange = (date) => {
    let { setSearchDataFields, searchDataFields } = this.props;
    setSearchDataFields({ ...searchDataFields, endDate: date });
  };

  render() {
    let {
      classes,
      handleRouteChange,
      openView,
      searchData,
      selectedPatientInfo,
      cardData: selectedCardData,
      searchDataFields,
      loading,
      ...restProps
    } = this.props;

    return openView === "searchOrders" ? (
      <MainPage
        {...restProps}
        routePath={
          selectedCardData.VisitType === 2
            ? "pendingFilesCard"
            : "scheduleCards"
        }
        isSearchType={true}
        title={names.SEARCH_ORDERS}
        loading={loading}
        handleRouteChange={this._handleRouteChange}
        data={searchData}
        selectedCardData={selectedCardData}
        selectedPatientInfo={selectedPatientInfo}
      />
    ) : (
      <div data-view="search-orders" className={classes.wrapper}>
        <div className={classes.scheduledVisitsHeader}>
          <div className={classes.formTitle}>{names.SEARCH_ORDERS}</div>
          <div className={classes.formContainer}>
            <div className={`${classes.formRow} ${classes.firstRow}`}>
              <div className={classes.inputWrapper}>
                <div className={classes.titleText}>ORDER NUMBER:</div>
                <input
                  id="orderId"
                  name="orderId"
                  onChange={this.onTextChange}
                  type="text"
                  className={`${classes.textInput} ${classes.orderNumber}`}
                  value={searchDataFields.orderId}
                />
              </div>
              <div className={classes.dateInputWrapper}>
                <div className={classes.inputWrapper}>
                  <div className={classes.titleText}>DATE RANGE:</div>
                  <DatePicker
                    id="startDate"
                    name="startDate"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="MM/DD/YYYY"
                    selected={searchDataFields.startDate}
                    className={`${classes.textInput} ${classes.dateTextInput}`}
                    onSelect={this.onStartDateChange} //when day is clicked
                    onChange={this.onStartDateChange} //only when value has changed
                  />
                </div>
                <div className={`${classes.titleText} ${classes.throughStyle}`}>
                  through
                </div>
                <div className={classes.inputWrapper}>
                  <div
                    className={`${classes.titleText} ${classes.placeholder}`}
                  >
                    placeholder
                  </div>
                  <DatePicker
                    id="endDate"
                    placeholderText="MM/DD/YYYY"
                    className={`${classes.textInput} ${classes.dateTextInput}`}
                    name="endDate"
                    dateFormat="MM/dd/yyyy"
                    selected={searchDataFields.endDate}
                    onSelect={this.onEndDateChange} //when day is clicked
                    onChange={this.onEndDateChange} //only when value has changed
                  />
                </div>
              </div>
            </div>

            <div className={`${classes.formRow}`}>
              <div className={classes.inputWrapper}>
                <div className={classes.titleText}>PATIENT FIRST NAME:</div>
                <input
                  id="firstName"
                  name="firstName"
                  onChange={this.onTextChange}
                  type="text"
                  className={`${classes.textInput} ${classes.orderNumber}`}
                  value={searchDataFields.firstName}
                />
              </div>
              <div className={classes.inputWrapper}>
                <div className={classes.titleText}>PATIENT LAST NAME:</div>
                <input
                  id="lastName"
                  name="lastName"
                  onChange={this.onTextChange}
                  type="text"
                  className={`${classes.textInput}`}
                  value={searchDataFields.lastName}
                />
              </div>
            </div>
            <Button
              id="searchButton"
              onClick={this.searchData}
              variant="contained"
              color="primary"
              className={`${classes.medButton}`}
            >
              SEARCH
            </Button>
          </div>
        </div>
        <div className={classes.scheduledVisitsBody}>
          {loading ? null : this.getCards(searchData)}
        </div>
      </div>
    );
  }
}

export default withStyles(SearchOrdersStyle)(SearchOrders);
